/**
 * Откат с разбросом.
 *
 * Разброс здесь не для красоты: несколько плиток на одной настенной панели
 * переподключаются одновременно, и без него они делают это в ногу, давая
 * серверу пачку одинаковых запросов вместо ровного потока.
 */
export class Backoff {
  private attempt = 0;

  constructor(
    private readonly baseMs = 1000,
    private readonly capMs = 15000,
    private readonly jitter = 0.25,
  ) {}

  /** Следующая задержка. */
  next(): number {
    const raw = Math.min(this.baseMs * 2 ** this.attempt, this.capMs);
    this.attempt += 1;
    const spread = raw * this.jitter;
    return Math.round(raw - spread + Math.random() * 2 * spread);
  }

  /**
   * Сбросить.
   *
   * Зовётся ТОЛЬКО когда поток подтверждённо здоров. Сброс по одному факту
   * «соединение установлено» превращал бы поток, который подключается и сразу
   * замирает, в плотный цикл переподключений.
   */
  reset(): void {
    this.attempt = 0;
  }

  get attempts(): number {
    return this.attempt;
  }
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
